export default __webpack_public_path__ + "static/media/touch-of-grey-bg.83e77dc9.jpeg";